import {gql} from '@apollo/client';

export const browseLink = '/browse';

/** Browse catalog: active markets + SEO copy from Drupal config. */
export const browseCatalogQuery = gql`
  {
    placesSettings
    browseSeo
    mainSettings
  }
`;

export const COUNTIES_PER_PAGE = 2000;
/** GAPI/ui-api `rows` for state county _place requests (default is 10). */
export const BROWSE_COUNTIES_API_ROWS = 200;
export const MARKETS_PER_PAGE = 200;
/** Properties per browse URL page (`/page-N`). */
export const PROPERTIES_PER_PAGE = 2000;
/** GAPI/ui-api max `rows` per _property_record request. */
export const BROWSE_PROPERTIES_API_ROWS = 400;

/** Same ranking as map Results tab (_property_record ui-api). */
export const BROWSE_PROPERTIES_BOOST_QUERY = JSON.stringify([
  {
    field: 'exclusionStatus',
    value: '*',
    negate: true,
    boost: 2,
  },
  {field: 'address', value: '*', boost: 1},
]);

export const BROWSE_BODY_COPY = {
  root: 'Find zoning districts in popular cities or search by region, city, or address.',
  state: state =>
    `Browse zoning details in ${state} by selecting a county below or search by region, city, or address.`,
  county: (county, state) =>
    `Browse zoning details in ${county}, ${state} by selecting a market below or search by region, city, or address.`,
  market: (market, county, state) =>
    `Find zoning districts in ${market}, ${county}, ${state}, or search by region, city, or address.`,
};

export const BROWSE_TITLES = {
  root: 'Browse PropZone by State',
  state: state => `${state} Counties`,
  county: (county, state) => `${county}, ${state}`,
  market: (market, county, state) => `${market} in ${county}, ${state}`,
};
